// extracted by mini-css-extract-plugin
export var metadataStyle = "rsc_hb_card_metadata-module--metadataStyle--jUzT1";